const creditsIT = {
    "view": {
        "form": {
            "title": "Ordina Crediti",
            "label": {
                "quantity": "Quantità"
            },
            "placeholder": {
                "quantity": "Seleziona Quantità"
            },
            "help_text": {
                "quantity": "Quantità di crediti che desideri ordinare."
            },
            "button": {
                "placeOrder": "Effettua Ordine"
            },
            "options": {
                "quantity": {
                    "selectQuantity": "Seleziona Quantità",
                    "1Credit": "1 Credito",
                    "2Credits": "2 Crediti",
                    "3Credits": "3 Crediti",
                    "4Credits": "4 Crediti",
                    "5Credits": "5 Crediti",
                    "10Credits": "10 Crediti",
                    "15Credits": "15 Crediti",
                    "20Credits": "20 Crediti",
                    "25Credits": "25 Crediti",
                    "30Credits": "30 Crediti",
                    "35Credits": "35 Crediti",
                    "40Credits": "40 Crediti",
                    "45Credits": "45 Crediti",
                    "50Credits": "50 Crediti",
                    "75Credits": "75 Crediti",
                    "100Credits": "100 Crediti"
                }
            },
            "message": {
                "quantityRequired": "Quantità richiesta",
                "paymentMethodRequired": "Per favore aggiungi un <1>metodo di pagamento</1> per effettuare l'ordine dei crediti.",
                "paymentMethodExpired": "Non puoi effettuare l'ordine dei crediti poiché il tuo <1>metodo di pagamento</1> predefinito è scaduto, per favore imposta un metodo di pagamento valido come predefinito per effettuare l'ordine dei crediti."
            }
        },
        "modal": {
            "header": "Procedi al checkout",
            "body": {
                "message": "Hai ordinato {{credits}} Crediti",
                "confirmationMessage": "Se vuoi confermare l'ordine, procedi al checkout, altrimenti puoi annullare l'ordine."
            },
            "button": {
                "cancel": "Annulla",
                "checkout": "Checkout"
            }
        },
        "message": {
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!"
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transazione Riuscita :)",
            "description": "Hai acquistato con successo i crediti che verranno presto aggiunti al tuo account!",
            "button": {
                "returnToDashboard": "Torna alla Dashboard"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transazione Annullata :(",
            "description": "La transazione è stata annullata... Per favore riprova più tardi!",
            "button": {
                "returnToDashboard": "Torna alla Dashboard"
            }
        }
    }
};

export default creditsIT;